import type { Tone } from "../utils/tones";

export type DrumId = "kick" | "snare" | "hat" | "clap" | "tom";

export interface DrumDef {
  id: DrumId;
  label: string;
  emoji: string;
  tone: Tone;
}

export const DRUMS: readonly DrumDef[] = [
  { id: "kick", label: "KICK", emoji: "🦶", tone: "red" },
  { id: "snare", label: "SNARE", emoji: "🥁", tone: "yellow" },
  { id: "hat", label: "HAT", emoji: "🎩", tone: "green" },
  { id: "clap", label: "CLAP", emoji: "👏", tone: "purple" },
  { id: "tom", label: "TOM", emoji: "🪘", tone: "orange" },
] as const;
